<template>
  <div>
    <el-input v-model="obj.search" size="small" placeholder="搜索 名称/代码/板块" style="width:300px" />
    <el-table :data="filterDataList" style="width: 100%" height="100%" empty-text=" " :style="'height:'+ (this.$store.state.windowHeight - 180)  +'px'" :cell-style="cellStyle" @row-click="handleRowClick">
      <el-table-column fixed label="序号" prop="no" width="60px" />
      <el-table-column fixed label="名称" prop="name" width="100px" sortable/>
      <el-table-column label="代码" prop="symbol" width="80px" sortable/>
      <el-table-column label="交易所" prop="exchange" width="100px" sortable/>
      <el-table-column :label="'最小\n变动'" prop="miniPoint" width="100px" sortable/>
      <el-table-column :label="'交易\n单位'" prop="unit" width="100px" sortable/>
      <el-table-column :label="'保证金\n(参考)'" prop="margin" width="100px" sortable/>
      <el-table-column :label="'保证金率(%)\n(参考)'" prop="marginRate" width="110px" sortable/>
      <el-table-column :label="'杠杆\n倍数'" prop="leverage" width="100px" sortable/>
      <el-table-column :label="'手续费\n(参考)'" prop="fee" width="100px" sortable/>
      <el-table-column :label="'日均波动点数\n(近5日)'" prop="point" width="120px" sortable/>
      <el-table-column :label="'日均波动金额\n(近5日)'" prop="rmb" width="120px" sortable/>
      <el-table-column :label="'波动金额\n/保证金(%)'" prop="rmbMargin" width="120px" sortable/>
      <el-table-column :label="'手续费\n/波动金额(%)'" prop="rmbFee" width="140px" sortable/>
      <el-table-column :label="'所属\n板块'" prop="block" width="120px" sortable/>
    </el-table>
  </div>
</template>
<script>
import { http } from '../util/http'
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  setup () {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      dataList: [],
      search: '',
    })

    // 搜索处理
    const filterDataList = computed(() =>
      obj.dataList.filter(
            (data) =>
              !obj.search ||
              data.name.toLowerCase().includes(obj.search.toLowerCase()) ||
              data.symbol.toLowerCase().includes(obj.search.toLowerCase()) || 
              data.block.toLowerCase().includes(obj.search.toLowerCase())
          )
    )

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      vueEvent.emit('navbarMenuIdxEvent', '') 
      vueEvent.emit('sidebarMenuIdxEvent', '3') 
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {

    })

    // 渲染画面
    const renderView = () => {
      requestData()
      
    }

    // 获取合约列表
    const requestData = () => {
      http({
        url: `/margin`,
        method: 'post',
      }).then((res) => {
        // console.log(res.data.data)
        processData(res.data.data)
      })
    }

    // 加工处理数据
    const processData = (data) => {
      let no = 1
      data.forEach((item) => {
        item.no = no
        no++
        item.rmbMargin = parseFloat(parseFloat(item.rmb / item.margin * 100).toFixed(0))
        item.rmbFee = parseFloat(parseFloat(item.fee / item.rmb * 100).toFixed(2))
      })
      obj.dataList = data
    }

    // 表格行点击事件
    const handleRowClick = (row) => {

    }

    // 表格单元格样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      if (row.columnIndex === 6) {
        return {color: '#409EFF'}
      } else if (row.row.margin > 0 && row.columnIndex === 7) {
        return {color: '#909399'}
      } else if (row.row.marginRate > 0 && row.columnIndex === 8) {
        return {color: '#909399'}
      } else if (row.columnIndex === 9) {
        return {color: '#409EFF'}
      } else if (row.columnIndex === 11) {
        return {color: '#409EFF'}
      } else if (row.columnIndex === 12) {
        return {color: '#409EFF'}
      } else if (row.columnIndex === 13) {
        return {color: '#409EFF'}
      }
    }

    return {
      obj,
      filterDataList,
      handleRowClick,
      cellStyle
    }
  }

}
</script>
<style lang="scss">
.el-table .cell {
 white-space: pre-line !important
}
</style>
